// extracted by mini-css-extract-plugin
export default {"title":"styles_title__HGRzw","left-content-max":"styles_left-content-max__k8bu5","left-content-min":"styles_left-content-min__dNo0q","absolute":"styles_absolute__l+oAj"};